import { Grid, Typography, useMediaQuery } from "@mui/material";

import moment from "moment";
import Note from "./note";

const BookingSummary = ({ info }) => {
  const isMobile = useMediaQuery("(max-width:800px)");
  return (
    <Grid
      sx={{
        px: isMobile ? 0 : 1,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
      }}
    >
      <Grid>
        <Typography fontWeight={"bold"} variant="body" color={"primary"}>
          Quote Info:
        </Typography>
        {info?.coordinates.map(({ address }, index) => (
          <Grid>
            <Typography fontWeight={"bold"} variant="caption">
              {index === 0
                ? "Start:"
                : index === info?.coordinates.length - 1
                ? "End:"
                : "Middle:"}
            </Typography>
            <Typography variant="caption"> {address}</Typography>
          </Grid>
        ))}
        <div style={{ wordBreak: "break-word" }}>
          <Typography fontWeight={"bold"} variant="caption">
            Item Details:
          </Typography>
          <Typography variant="caption"> {info?.itemDescription}</Typography>
        </div>
        <div>
          <Typography fontWeight={"bold"} variant="caption">
            Pessengers:
          </Typography>
          <Typography variant="caption"> {info?.peopleInVan}</Typography>
        </div>
        {/* <div>
          <Typography fontWeight={"bold"} variant="caption">
            Loaders:
          </Typography>
          <Typography variant="caption"> {info?.loaderInVan}</Typography>
        </div> */}
        <div>
          <Typography fontWeight={"bold"} variant="caption">
            Total Distance:
          </Typography>
          <Typography variant="caption"> {info?.distance} miles</Typography>
        </div>
        <div>
          <Typography fontWeight={"bold"} variant="caption">
            Price:
          </Typography>
          <Typography variant="caption"> £ {info?.price}</Typography>
        </div>
      </Grid>

      <Grid>
        <Typography fontWeight={"bold"} variant="body" color={"primary"}>
          Date / Time Info:
        </Typography>
        <div>
          <Typography fontWeight={"bold"} variant="caption">
            Start Date / Time:
          </Typography>
          <Typography variant="caption">
            &nbsp;{moment(info?.date).format("dddd Do MMMM YYYY")} / {info?.time}
          </Typography>
        </div>
        <div style={{ wordBreak: "break-word" }}>
          <Typography variant="caption" fontWeight={"bold"}>
            Other Relevant Info:
          </Typography>
          <Typography variant="caption">
            &nbsp;{info?.otherInformation}
          </Typography>
        </div>
      </Grid>

      <Grid>
        <Typography fontWeight={"bold"} variant="body" color={"primary"}>
          Contact Info:
        </Typography>

        <div>
          <Typography fontWeight={"bold"} variant="caption">
            Name:
          </Typography>
          <Typography variant="caption">
            &nbsp;{info?.firstName} {info?.lastName}
          </Typography>
        </div>
        <div>
          <Typography fontWeight={"bold"} variant="caption">
            Email:&nbsp;
          </Typography>
          <Typography
            sx={{ textDecoration: "underline" }}
            variant="caption"
            color={"primary"}
          >
            {info?.email}
          </Typography>
        </div>

        <div>
          <Typography fontWeight={"bold"} variant="caption">
            Phone number:
          </Typography>
          <Typography variant="caption">&nbsp;{info?.phoneNumber}</Typography>
        </div>
        <Note />
      </Grid>
    </Grid>
  );
};

export default BookingSummary;
